import React from 'react';
import { Minus, Plus } from 'lucide-react';

const QuantitySelector = ({
  value,
  onChange,
  min = 1,
  max = 99,
  size = 'md',
  disabled = false,
}) => {
  const sizes = {
    sm: {
      button: 'w-8 h-8',
      text: 'w-10 text-sm',
      icon: 14,
    },
    md: {
      button: 'w-10 h-10',
      text: 'w-14 text-base',
      icon: 18,
    },
    lg: {
      button: 'w-12 h-12',
      text: 'w-16 text-lg',
      icon: 22,
    },
  };

  const currentSize = sizes[size];

  const handleDecrease = () => {
    if (value > min && !disabled) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max && !disabled) {
      onChange(value + 1);
    }
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={handleDecrease}
        disabled={disabled || value <= min}
        className={`
          ${currentSize.button}
          flex items-center justify-center
          rounded-xl
          border-2 border-[#EFEDEA]
          text-[#1B263B]
          transition-all duration-200
          touch-manipulation
          ${value <= min || disabled 
            ? 'opacity-40 cursor-not-allowed' 
            : 'hover:border-[#E85D04] hover:text-[#E85D04] active:scale-95'
          }
        `}
        aria-label="Disminuir cantidad"
      >
        <Minus size={currentSize.icon} />
      </button>
      
      <input
        type="number"
        value={value}
        onChange={handleInputChange}
        min={min}
        max={max}
        disabled={disabled}
        className={`
          ${currentSize.text}
          h-10
          text-center
          font-semibold
          text-[#1B263B]
          bg-white
          border-2 border-[#EFEDEA]
          rounded-xl
          focus:border-[#E85D04] focus:outline-none
          disabled:opacity-50
          [appearance:textfield]
          [&::-webkit-outer-spin-button]:appearance-none
          [&::-webkit-inner-spin-button]:appearance-none
        `}
        aria-label="Cantidad"
      />
      
      <button
        type="button"
        onClick={handleIncrease}
        disabled={disabled || value >= max}
        className={`
          ${currentSize.button}
          flex items-center justify-center
          rounded-xl
          border-2 border-[#EFEDEA]
          text-[#1B263B]
          transition-all duration-200
          touch-manipulation
          ${value >= max || disabled 
            ? 'opacity-40 cursor-not-allowed' 
            : 'hover:border-[#E85D04] hover:text-[#E85D04] active:scale-95'
          }
        `}
        aria-label="Aumentar cantidad"
      >
        <Plus size={currentSize.icon} />
      </button>
    </div>
  );
};

export default QuantitySelector;
